export const superAdminPromoteAssignedKegsMutation = /* GraphQL */ `mutation SuperAdminPromoteAssignedKegs($input: inputSuperAdminPromoteAssignedKegs!) {
	superAdminPromoteAssignedKegs(input: $input){
      id  
    }}`
